module.exports = __webpack_public_path__ + "img/doudian.2e137aac.png";